import { Map } from 'immutable';
import * as Actions from '../../actions/accountHistory';
var initialState = new Map({
    isLoading: false,
    data: undefined,
    error: false
});
export default function accountHistoryReducer(state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case Actions.CLEAR_ACCOUNT_HISTORY:
            return initialState;
        case Actions.FETCH_ACCOUNT_HISTORY:
            state = state.set('isLoading', true);
            return state;
        case Actions.SUCCESS_FETCH_ACCOUNT_HISTORY:
            state = state.update('isLoading', function () { return false; });
            state = state.update('error', function () { return false; });
            return state.update('data', function () { return action.data; });
        case Actions.FAILURE_FETCH_ACCOUNT_HISTORY:
            state = state.update('isLoading', function () { return false; });
            return state.update('error', function () { return true; });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/account-history/accountHistoryReducer.js